import Yup from '../../../../utils/yup';
import { INPUT_VARIANT } from '../../../Forms/StepsForm/fieldsSelector';
import {
  POSITION_CHOICES,
  COMPANY_CHOICES,
  RELATION_CHOICES,
} from 'src/components/Cognito/StepThreeForm/LinkedPeople/constants';

const LINKED_TYPES_SHORT = [
  {
    value: 'SP',
    label: 'Cónyuge/Conviviente',
    enum: 'SPOUSE',
  },
  {
    value: 'PGP',
    label: 'Abuelo/a Paterno',
    enum: 'PATERNAL_GRAND_PARENT',
  },
  {
    value: 'MGP',
    label: 'Abuelo/a Materno',
    enum: 'MATERNAL_GRAND_PARENT',
  },
  {
    value: 'P',
    label: 'Padre/Madre',
    enum: 'PARENT',
  },
  {
    value: 'PIL',
    label: 'Suegro/a',
    enum: 'PARENT_IN_LAW',
  },
  {
    value: 'S',
    label: 'Hermano/a',
    enum: 'SIBLING',
  },
  // {
  //   value: 'SIL',
  //   label: 'Cuñado/a',
  //   enum: 'SIBLING_IN_LAW',
  // },
  {
    value: 'C',
    label: 'Hijo/a',
    enum: 'CHILD',
  },
  {
    value: 'CIL',
    label: 'Yerno/Nuera',
    enum: 'CHILD_IN_LAW',
  },
  {
    value: 'GC',
    label: 'Nieto/a',
    enum: 'GRANDCHILD',
  },
  {
    value: 'SC',
    label: 'Hijastro/a',
    enum: 'STEPCHILD',
  },
];

const userTypes = [
  { token: 'PN', id: 'PERSONA_NATURAL', name: 'Persona natural' },
  { token: 'PJ', id: 'PERSONA_JURIDICA', name: 'Persona jurídica' },
  { token: 'AU', id: 'PERSONA_AUTONOMA', name: 'Persona autónoma' },
];

export const startData = {
  promoterCompany: '',
  promoter: '',
  coreConsultant: '',
  intermediaryPromoter: '',
  documentType: '',
  documentNumber: '',
  verificationDigit: '',
  firstName: '',
  lastName: '',
  maternalSurname: '',
  email: '',
  cellphone: '',
  userType: '',
  leadsProducts: [],
  // leadsChannel: '',
  // leadsChannelDetail: '',
  leadsRange: '',
  canalActual: '',
  canalOrigen: '',
  enviarComunicacion: '',
  nombreComunicacion: '',
  nombreCanalActual: '',
  nombreCanalOrigen: '',
  correoIntermediario: '',
  sex: '',
  photoDocumentFront: null,
  photoDocumentBack: null,
  linkedType: '',
  firstNameLinked: '',
  lastNameLinked: '',
  maternalSurnameLinked: '',
  documentTypeLinked: '',
  documentNumberLinked: '',
  company: '',
  position: '',
  relation: '',
};

export const formStructure = (
  isEdit,
  isOnlyCore,
  promoterCompanies,
  promoters,
  corePromoters,
  intermediaries,
  documentTypes,
  leadsProducts,
  onChangePromoterCompany,
  onChangeDocumentType,
  isNational,
  // leadsChannels,
  // leadsChannelsDetail,
  leadsRanges,
  canalActual,
  canalOrigen,
  isDirect,
  handleRelationChange,
) => {
  let structure = [
    {
      label: 'Empresa Promotora',
      name: 'promoterCompany',
      inputVariant: INPUT_VARIANT.select,
      gridMD: 6,
      data: promoterCompanies,
      mapData: { value: 'id', label: 'businessName' },
      onChange: onChangePromoterCompany,
    },
    {
      label: 'Promotor',
      name: 'promoter',
      inputVariant: INPUT_VARIANT.select,
      gridMD: 6,
      data: promoters,
      mapData: { value: 'id', label: 'fullName' },
      disabled: isOnlyCore,
    },
    {
      label: 'Asesor de Core',
      name: 'coreConsultant',
      inputVariant: INPUT_VARIANT.select,
      gridMD: 6,
      data: corePromoters,
      mapData: { value: 'id', label: 'fullName' },
    },
    {
      label: 'Intermediario',
      name: 'intermediaryPromoter',
      inputVariant: INPUT_VARIANT.select,
      gridMD: 6,
      data: intermediaries,
      mapData: { value: 'id', label: 'fullName' },
    },
    {
      label: 'Nombres',
      name: 'firstName',
      gridMD: 4,
      inputVariant: INPUT_VARIANT.text,
      disabled: isEdit,
    },
    {
      label: 'Apellido Paterno',
      name: 'lastName',
      gridMD: 4,
      inputVariant: INPUT_VARIANT.text,
      disabled: isEdit,
    },
    {
      label: 'Apellido Materno',
      name: 'maternalSurname',
      gridMD: 4,
      inputVariant: INPUT_VARIANT.text,
      disabled: isEdit,
    },
    {
      label: 'Tipo de documento',
      name: 'documentType',
      gridMD: 6,
      inputVariant: INPUT_VARIANT.select,
      data: documentTypes,
      mapData: { value: 'id', label: 'name' },
      disabled: isEdit,
      onChange: onChangeDocumentType,
    },
    {
      label: 'Número de documento',
      name: 'documentNumber',
      gridMD: 6,
      inputVariant: isNational ? INPUT_VARIANT.number : INPUT_VARIANT.text,
      disabled: isEdit,
    },
    {
      label: 'Digito Verificador',
      name: 'verificationDigit',
      gridMD: 4,
      inputVariant: INPUT_VARIANT.number,
    },
    {
      label: 'Email',
      name: 'email',
      gridMD: 6,
      inputVariant: INPUT_VARIANT.text,
    },
    {
      label: 'Celular',
      name: 'cellphone',
      gridMD: 6,
      inputVariant: INPUT_VARIANT.text,
    },
    {
      label: 'Rol',
      name: 'userType',
      gridMD: 12,
      inputVariant: INPUT_VARIANT.select,
      data: userTypes,
      mapData: { value: 'id', label: 'name' },
    },
    // {
    //   label: 'Canal',
    //   name: 'leadsChannel',
    //   inputVariant: INPUT_VARIANT.select,
    //   gridMD: 6,
    //   data: leadsChannels,
    //   mapData: { value: 'value', label: 'name' },
    // },
    // {
    //   label: 'Detalle Canal',
    //   name: 'leadsChannelDetail',
    //   inputVariant: INPUT_VARIANT.select,
    //   gridMD: 6,
    //   data: leadsChannelsDetail,
    //   mapData: { value: 'value', label: 'name' },
    // },
    {
      label: 'Rangos',
      name: 'leadsRange',
      inputVariant: INPUT_VARIANT.select,
      gridMD: 6,
      data: leadsRanges,
      mapData: { value: 'value', label: 'name' },
    },
    {
      label: 'Género',
      name: 'sex',
      inputVariant: INPUT_VARIANT.select,
      gridMD: 6,
      data: [
        { value: 'M', name: 'Masculino' },
        { value: 'F', name: 'Femenino' },
      ],
      mapData: { value: 'value', label: 'name' },
    },
    {
      label: 'Foto del anverso del documento',
      name: 'photoDocumentFront',
      gridMD: 12,
      inputVariant: INPUT_VARIANT.image,
    },
    {
      label: 'Foto del reverso del documento',
      name: 'photoDocumentBack',
      gridMD: 12,
      inputVariant: INPUT_VARIANT.image,
    },
    {
      isField: false,
      section: 'Radiografía',
      fields: [
        {
          label: 'Nombre de Comunicación',
          name: 'nombreComunicacion',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.text,
        },
        {
          label: 'Enviar Comunicación',
          name: 'enviarComunicacion',
          inputVariant: INPUT_VARIANT.select,
          gridMD: 6,
          data: [
            { value: true, name: 'Si' },
            { value: false, name: 'No' },
          ],
          mapData: { value: 'value', label: 'name' },
        },
        {
          label: 'Nombre Canal Actual',
          name: 'nombreCanalActual',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.text,
        },
        {
          label: 'Canal Actual',
          name: 'canalActual',
          inputVariant: INPUT_VARIANT.select,
          gridMD: 6,
          data: canalActual,
          mapData: { value: 'value', label: 'name' },
        },
        {
          label: 'Nombre Canal Origen',
          name: 'nombreCanalOrigen',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.text,
        },
        {
          label: 'Canal de Origen',
          name: 'canalOrigen',
          inputVariant: INPUT_VARIANT.select,
          gridMD: 6,
          data: canalOrigen,
          mapData: { value: 'value', label: 'name' },
        },
        {
          label: 'Correo Intermediario',
          name: 'correoIntermediario',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.text,
        },
      ],
    },
    {
      isField: false,
      section: 'Productos de Interés',
      fields: [
        {
          name: 'fundRelationText',
          text:
            'A continuación indique los productos de su interés (Puedes marcar más de una opción): ',
          gridMD: 12,
          inputVariant: INPUT_VARIANT.paragraph,
          type: 'relation',
        },
        {
          label: '',
          data: leadsProducts,
          name: 'leadsProducts',
          mapData: { value: 'id', label: 'name' },
          inputVariant: INPUT_VARIANT.checkbox,
          other: false,
          gridMD: 12,
        },
      ],
    },
  ];

  if (!isEdit) {
    structure.push({
      isField: false,
      section: 'Vinculados',
      fields: [
        {
          isField: true,
          label: 'Relación',
          name: 'relation',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.select,
          data: RELATION_CHOICES,
          mapData: { value: 'value', label: 'label' },
          onChange: handleRelationChange,
          // linkedPeopleData: selectedClient,
        },
        {
          isField: true,
          label: 'Cargo',
          name: 'position',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.select,
          data: POSITION_CHOICES,
          mapData: { value: 'value', label: 'label' },
        },
        {
          isField: true,
          label: 'Compañia',
          name: 'company',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.select,
          data: COMPANY_CHOICES,
          mapData: { value: 'value', label: 'label' },
        },
        {
          isField: true,
          label: 'Vinculación',
          name: 'linkedType',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.select,
          data: LINKED_TYPES_SHORT,
          mapData: { value: 'value', label: 'label' },
          disabled: isDirect,
        },
        {
          isField: true,
          label: 'Nombres',
          name: 'firstNameLinked',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.onlyText,
        },
        {
          isField: true,
          label: 'Apellido Paterno',
          name: 'lastNameLinked',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.onlyText,
        },
        {
          isField: true,
          label: 'Apellido Materno',
          name: 'maternalSurnameLinked',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.onlyText,
        },
        {
          isField: true,
          label: 'Tipo de documento',
          name: 'documentTypeLinked',
          inputVariant: INPUT_VARIANT.select,
          gridMD: 6,
          isLinkedSelect: true,
          data: documentTypes,
          mapData: { value: 'id', label: 'name' },
          onChange: onChangeDocumentType,
        },
        {
          isField: true,
          label: 'Número de documento',
          name: 'documentNumberLinked',
          gridMD: 6,
          inputVariant: INPUT_VARIANT.text,
        },
      ],
    });
  }

  return structure;
};

export const bankAccountValidationSchema = Yup.object().shape({});

export const bankAccountFormStructure = [];
